import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeUuid, employeesNotDeleted } from 'src/store/selectors';
import { currentContactUuid } from 'src/store/selectors';
import { getContactsAsUsers } from 'src/store/selectors';

export const currentUserName = createSelector(
  currentEmployeeUuid,
  currentContactUuid,
  employeesNotDeleted,
  getContactsAsUsers,
  function (employeeUuid, contactUuid, employees, contacts): string {
    if (employeeUuid) {
      const employee = employees.find((e) => {
        return e.uuid === employeeUuid;
      });
      if (employee) {
        return employee.name;
      }
    }
    if (contactUuid) {
      const contact = contacts.find((c) => {
        return c.uuid === contactUuid;
      });
      if (contact) {
        return contact.name + ' (' + contact.partnerName + ')';
      }
    }
    return '';
  },
);
